module.exports = __webpack_public_path__ + "img/home_four_002.f62c444b.png";